// Corrige `TypeError: crypto.randomUUID is not a function` ao acessar o app fora de um "contexto
// seguro" do browser (secure context = HTTPS, ou HTTP em `localhost`/`127.0.0.1`). O dev server
// deste projeto é normalmente acessado por um host Tailscale via HTTP puro — `start.sh` imprime
// `ACCESS_URL="http://${DEV_TAILSCALE_HOST}:${APP_PORT}"`, e `next.config.ts` já lista esse IP e
// hostname em `allowedDevOrigins` — e HTTP não-localhost NUNCA é secure context, então
// `crypto.randomUUID` fica indefinido nesse acesso mesmo em browsers atuais.
//
// Achado ao investigar o toast "crypto.randomUUID is not a function" ao gerar PDF em Documentos:
// o mesmo padrão (`crypto.randomUUID()` cru, para o header `Idempotency-Key`) se repete em ~124
// componentes client do app inteiro — toda ação que muda dado (salvar, excluir, mover, gerar PDF)
// está sujeita ao mesmo erro. Em vez de tocar cada call site, este arquivo aplica UM polyfill
// condicional, uma única vez, antes de qualquer código client rodar (recurso nativo do Next —
// arquivo na raiz do projeto, ao lado de `next.config.ts`; roda antes da hidratação).
//
// `crypto.getRandomValues` NÃO é restrito a secure context (só `randomUUID` e `subtle` são), então
// dá para gerar um UUID v4 real e criptograficamente forte mesmo no contexto inseguro — não é um
// fallback fraco baseado em `Math.random()`.
if (
  typeof window !== 'undefined' &&
  window.crypto &&
  typeof window.crypto.randomUUID !== 'function'
) {
  window.crypto.randomUUID = randomUUIDPolyfill;
}

function randomUUIDPolyfill(): `${string}-${string}-${string}-${string}-${string}` {
  const bytes = window.crypto.getRandomValues(new Uint8Array(16));
  bytes[6] = (bytes[6] & 0x0f) | 0x40; // versão 4
  bytes[8] = (bytes[8] & 0x3f) | 0x80; // variante RFC 4122
  const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, '0'));
  return `${hex.slice(0, 4).join('')}-${hex.slice(4, 6).join('')}-${hex.slice(6, 8).join('')}-${hex.slice(8, 10).join('')}-${hex.slice(10, 16).join('')}` as `${string}-${string}-${string}-${string}-${string}`;
}

// Sem nenhum `import`/`export`, o TypeScript trata este arquivo como um script global (não um
// módulo) e recusa o `import()` dinâmico do teste com TS2306. Efeito zero em runtime — o Next
// já trata todo arquivo do bundle como módulo ESM independentemente disto.
export {};
